import React from 'react';

const GoogleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 23 24" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.54 12.2615C22.54 11.446 22.4668 10.6619 22.3309 9.90918H11.5V14.3576H17.6891C17.4225 15.7951 16.6123 17.013 15.3943 17.8285V20.714H19.1109C21.2855 18.7119 22.54 15.7637 22.54 12.2615Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4995 23.4996C14.6045 23.4996 17.2077 22.4698 19.1104 20.7134L15.3938 17.828C14.364 18.518 13.0467 18.9257 11.4995 18.9257C8.50425 18.9257 5.96902 16.9028 5.0647 14.1846H1.22266V17.1641C3.11493 20.9225 7.00402 23.4996 11.4995 23.4996Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.06523 14.1855C4.83523 13.4955 4.70455 12.7584 4.70455 12.0005C4.70455 11.2425 4.83523 10.5055 5.06523 9.81548V6.83594H1.22318C0.444318 8.38844 0 10.1448 0 12.0005C0 13.8562 0.444318 15.6125 1.22318 17.165L5.06523 14.1855Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4995 5.07386C13.1879 5.07386 14.7038 5.65409 15.8956 6.79364L19.194 3.49523C17.2024 1.63955 14.5992 0.5 11.4995 0.5C7.00402 0.5 3.11493 3.07705 1.22266 6.83545L5.0647 9.815C5.96902 7.09682 8.50425 5.07386 11.4995 5.07386Z"
      fill="#EA4335"
    />
  </svg>
);

export default GoogleIcon;
